import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Team, MoreAboutUs} from '../../components/index';
import {get} from '../../redux/modules/about';

class About extends PureComponent {
  componentWillMount() {
    this.props.getAction();
  }

  render() {
    const {about: {values, isFetching}} = this.props;
    if (isFetching) {
      return <div/>;
    }

    return (
      <div className="main container">
        <MoreAboutUs values={values.about}/>
        <Team values={values.team}/>
      </div>
    );
  }
}

export default connect(
  (state) => {
    return {
      about: state.about
    };
  },
  (dispatch) => {
    return bindActionCreators(
      {
        getAction: get
      }, dispatch);
  }
)(About);




// WEBPACK FOOTER //
// ./src/containers/about/About.js